import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, GitCompare } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { COMPETITORS } from '../mock';

export default function ComparisonHub() {
  return (
    <div className="min-h-screen bg-[#0a0a0c]">
      <Navbar />
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-14 md:pt-20 pb-8">
        <Badge className="bg-[#14141a] border border-[#26262e] text-[#c9c6bf] hover:bg-[#14141a] rounded-full mb-5">Compare</Badge>
        <h1 className="serif text-5xl md:text-6xl text-white leading-[1.02] max-w-3xl">CrewFace vs. every other AI headshot tool.</h1>
        <p className="text-[#a8a49b] mt-5 max-w-2xl text-lg">The AI headshot space is crowded with tools for individuals. CrewFace is the only one purpose-built for onboarding field crews. Here’s how we stack up against the closest alternatives — honestly.</p>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-16 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {COMPETITORS.map((c) => (
          <Link key={c.slug} to={`/compare/${c.slug}`} className="group bg-[#101014] border border-[#1e1e26] rounded-2xl p-6 hover:border-[#ea9a6f]/50 transition-colors">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-[#1a1a20] border border-[#26262e] flex items-center justify-center serif text-[#ea9a6f]">{c.logoInitial}</div>
              <GitCompare className="w-4 h-4 text-[#5a5850]" />
              <div className="w-10 h-10 rounded-lg bg-[#ea9a6f] flex items-center justify-center serif text-[#0a0a0c] font-semibold">CF</div>
            </div>
            <h2 className="serif text-2xl text-white leading-tight">CrewFace vs {c.name}</h2>
            <p className="text-sm text-[#8a877f] mt-2 mb-4">{c.tagline}</p>
            <div className="mono text-xs text-[#5a5850] uppercase tracking-wider">{c.positioning}</div>
            <div className="mt-5 pt-4 border-t border-[#1a1a20] flex items-center text-sm text-[#ea9a6f] group-hover:gap-2 transition-all gap-1">
              Read comparison <ArrowRight className="w-4 h-4" />
            </div>
          </Link>
        ))}
      </section>

      <section className="max-w-4xl mx-auto px-5 md:px-8 py-10 text-center">
        <h2 className="serif text-3xl md:text-4xl text-white">Still evaluating?</h2>
        <p className="text-[#a8a49b] mt-3 max-w-xl mx-auto">Skip the comparison spreadsheet. Try 2 headshots free, then decide.</p>
        <Link to="/sign-up">
          <Button className="bg-[#ea9a6f] hover:bg-[#e0895a] text-[#0a0a0c] rounded-full h-11 px-6 mt-6 glow-coral">Try CrewFace free <ArrowRight className="ml-1.5 w-4 h-4" /></Button>
        </Link>
      </section>
      <Footer />
    </div>
  );
}
